import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import * as S from './BlockCategory.styled'
import * as catalogService from '@services/catalogService'
import { useGroups } from '@entities/groups/hooks'

const generateLink = (id, allGroups) => {
    const three = []
    let node = allGroups.find((x) => x.id === id)
    if (!node) {
        return ''
    }
    three.push(node.id)
    while (node.parentClsGroupId) {
        node = allGroups.find((x) => x.id === node.parentClsGroupId)
        if (node) three.push(node.id)
    }
    return three.reverse().join('/')
}

const BlockCategory = ({
    id,
    title,
    parrentGroupTitle,
    imgUrl = `${process.env.NEXT_PUBLIC_BASE_PATH || ''}/images/noimg.gif`
}) => {
    const groups = useGroups()

    return (
        <Link href={`/catalog/${generateLink(id, groups)}`} passHref legacyBehavior>
            <S.Container>
                <S.ImageContainer>
                    <S.Image
                        src={imgUrl}
                        onError={(e) => {
                            e.target.onerror = null
                            e.target.src = catalogService.errorImage
                        }}
                    />
                </S.ImageContainer>
                <S.TextContainer>
                    <S.Title>{title}</S.Title>
                    <S.TitleParrent>{parrentGroupTitle}</S.TitleParrent>
                </S.TextContainer>
            </S.Container>
        </Link>
    )
}

BlockCategory.propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    imgUrl: PropTypes.string.isRequired,
    parrentGroupTitle: PropTypes.string
}

export default BlockCategory
